import { WSS } from '../../../ws'
import { singleItemWrapper } from '../../../api-client/wrappers'
import type { Starter, Options, WSOptions } from '../../types/internal'
import type { Settings, State } from './types'

interface CommonOptions extends Options, WSOptions {}

export default {
  defaultOptions: host => ({
    shouldInstantiateWS: typeof window !== 'undefined',
    hostWS: host,
    pathWS: 'ws/connection'
  }),

  factory: (
    { shouldInstantiateWS, hostWS, pathWS, apiClient, version },
    { module }
  ) => {
    if (pathWS === undefined) {
      throw new ReferenceError('pathWS must be specified in defaultOptions')
    }

    let ws: WSS | null = null

    if (shouldInstantiateWS) {
      const { href } = new URL(pathWS, hostWS || location.origin)
      ws = new WSS(href)
    }

    if (ws) {
      ws.getAuthorizationToken = () =>
        module('auth').then(({ getAuthorizationToken }) =>
          getAuthorizationToken()
        )
    }

    const getWSInstance = () => {
      if (!ws) {
        throw new TypeError('WS is not instantiated')
      }

      return ws
    }

    const { get: getSettings } = singleItemWrapper<Settings>(apiClient, {
      path: `/api/v${version}/settings`,
      requestOptions: {
        cache: {
          ttl: 300000 // 5m
        }
      }
    })

    const { get: getState } = singleItemWrapper<State>(apiClient, {
      path: `/api/v${version}/state`
    })

    return {
      ws,
      getWSInstance,
      getSettings,
      getState
    }
  }
} satisfies Starter<CommonOptions>
